import React from 'react';
import { Link } from 'react-router-dom';
import { BrandButton } from './BrandButton';
import { Reveal } from './showcase/Reveal';
interface NextStepPanelProps {
  title: string;
  buttonLabel: string;
  to: string;
  body?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}
export function NextStepPanel({
  title,
  buttonLabel,
  to,
  body,
  secondaryLabel,
  secondaryTo
}: NextStepPanelProps) {
  return <section aria-labelledby="next-step-title" className="bg-ink-800" data-id="element-154" data-mp="3fisqbqtob1jz">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-155" data-mp="3khccnsc6ifcv">
        <Reveal data-id="element-156" data-mp="3kinf9otw1h2e">
          <div className="flex flex-col gap-8 rounded-2xl border border-white/10 bg-ink-700 p-8 sm:p-12 lg:flex-row lg:items-center lg:justify-between" data-id="element-157" data-mp="35s7rq3e01x12">
            <div className="max-w-xl" data-id="element-158" data-mp="3ap6m8n1ks5zs">
              <h2 id="next-step-title" className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-159" data-mp="2bhizgr195vo">
                {title}
              </h2>
              {body && <p className="mt-4 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-160" data-mp="239b9gdkojrdi">
                  {body}
                </p>}
            </div>

            <div className="flex flex-none flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-161" data-mp="2c1d8c7f3ozlo">
              <BrandButton label={buttonLabel} to={to} size="lg" withArrow data-id="element-162" data-mp="27a4xr821b86x" />
              {secondaryLabel && secondaryTo && <Link to={secondaryTo} className="rounded text-sm font-medium text-white/70 underline decoration-white/25 underline-offset-4 transition-colors hover:text-brand hover:decoration-brand focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-163" data-mp="2lxq2t7igzhhh">
                  {secondaryLabel}
                </Link>}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}